import cn from 'classnames';

import AemButton from '@/components/Aem/AemButton';
import RemoteIconV2 from '@/components/Icon/RemoteIconV2';
import AGE_GATE_INPUTS from '@/consts/ageGateInputs';
import appContent from '@/services/content/appContent.typed';

import useAgeGate from '../hooks/useAgeGate';
import styles from './AgeGateForm.module.scss';
import DateInput from './DateInput';

export const AgeGateForm = ({onLocked}: {onLocked: () => void}) => {
    const {
        icon,
        title,
        description,
        secondaryDescription,
        monthTitle,
        monthPlaceholder,
        yearTitle,
        yearPlaceholder,
        primaryButton,
    } = appContent.getAgeGatePopupContent() || {};

    const form = useAgeGate({onLocked});
    const {register, handleSubmit, formState, onSubmit, isLoading, monthOptions, yearOptions, control} = form;

    return (
        <div className='flex flex-1 justify-center bg-romance'>
            <form
                noValidate
                className='flex flex-1 flex-col pb-safe-offset-8 md:my-auto md:flex-initial'
                onSubmit={handleSubmit(onSubmit)}
            >
                <div className='mx-6 flex w-auto flex-1 flex-col items-center justify-center gap-4 md:flex-initial'>
                    <div className='flex flex-col items-center justify-center gap-2'>
                        {icon && <RemoteIconV2 icon={icon} className='m-2 size-12' />}
                        <h1 className='m-0 text-center text-32 font-bold leading-12'>{title}</h1>
                        <p className='flex flex-col text-center text-16 leading-15'>
                            <span>{description}</span>
                            <span className='mt-[1lh]'>{secondaryDescription}</span>
                        </p>
                    </div>
                    <div className='flex w-full flex-row gap-2'>
                        <DateInput
                            name={AGE_GATE_INPUTS.MONTH}
                            title={monthTitle}
                            options={monthOptions}
                            register={register}
                            control={control}
                            ariaLabel={monthTitle}
                            placeholder={monthPlaceholder}
                            isLoading={isLoading}
                            testId='month-input'
                        />
                        <DateInput
                            name={AGE_GATE_INPUTS.YEAR}
                            title={yearTitle}
                            options={yearOptions}
                            register={register}
                            control={control}
                            ariaLabel={yearTitle}
                            placeholder={yearPlaceholder}
                            isLoading={isLoading}
                            testId='year-input'
                        />
                    </div>
                </div>
                <div className='mt-auto w-full px-6 md:mt-4'>
                    <AemButton
                        disabled={!formState.isValid || isLoading}
                        primary
                        light
                        loading={isLoading}
                        type='submit'
                        className={cn(
                            'mt-0 w-full md:mx-auto md:mt-4 md:w-auto md:self-center md:px-6',
                            // @ts-expect-error scss module typing
                            styles.Disabled
                        )}
                        testId='continue-button'
                        {...primaryButton}
                        checkOffline
                    />
                </div>
            </form>
        </div>
    );
};
